import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const DownpaymentModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerDownPaymentModal}
    contentClassName={cx(
      styles.containerMenuContent,
      styles.isWidePadding,
    )}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    titleClassName={styles.containerTitle}
    onClose={onClose}>
    <div>
      The difference between the car price and the loan amount.
      <br />
    </div>
    <div>
      Effective from 26 May 2016, minimum down payment will be dependent
      on Open market value (OMV) of the car. Cars with OMV exceeding
      $20,000 will be entitled to a maximum loan value of 60% of car
      price (minimum 40% down payment) whereas OMV $20,000 and below
      will be 70% of car price (minimum 30% down payment).
      <br />
    </div>
    <div>
      The loan term is a maximum of 7 years.
      <br />
    </div>
    <div>
      These financing restrictions does not apply to loans for purchase
      of commercial vehicles (not including goods-cum-passengers vehicles).
    </div>
  </PlainModal>
);
